import { useQuery } from '@tanstack/react-query';
import { useUserStore } from './useUser';

export const useUserCredits = () => {
  const { user, customerDetails, isProMemberActive } = useUserStore();

  return useQuery({
    queryKey: ['userCredits', user?.uid, customerDetails?.stripeCustomerId],
    queryFn: async () => {
      if (!user?.uid) return null;

      const response = await fetch(`/api/credits?userId=${user.uid}&customerId=${customerDetails?.stripeCustomerId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch credit information');
      }

      return response.json();
    },
    enabled: !!user?.uid && !!customerDetails?.stripeCustomerId && !!isProMemberActive,
  });
};
